import React from 'react';

class CameraTestRecord extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            recording: false,
            audios: [],
        };
    }

    async componentDidMount() {

    }





    render() {

        return (
            <div className="ttttttt">

            </div>
        );
    }
}

export default CameraTestRecord
